/**
 * MapLibre bearing is degrees clockwise from north.
 * SVG north arrows are drawn pointing up (screen north), so rotate by -bearing.
 */
export function northArrowRotationDeg(bearingDeg: number): number {
  if (!Number.isFinite(bearingDeg)) return 0;
  const normalized = ((bearingDeg % 360) + 360) % 360;
  if (normalized === 0) return 0;
  return -normalized;
}
